import './slider/_slider';
import './themes/header/_header';
import './themes/woocommerce/_woocommerce';
import './themes/navigate/_navigate';
import './themes/accordion/_accordion';
import './themes/the-event-calendar/_the-event-calendar';